import { Box, Container, Typography } from '@material-ui/core'

import outreachEmptyState from './empty-state.jpeg'

export const MarketingEmptyState = () => {
  return (
    <Container maxWidth="md">
      <Box textAlign="center">
        <Box mb={2}>
          <Typography variant="h3">Upgrade your Plan to Send Messages with Powerful Segmentation</Typography>
        </Box>
        <Typography
          variant="body1"
          paragraph
        >
          Reach the right students with targeted outreach. Upgrade to unlock unlimited messaging to students and
          parents/guardians.
        </Typography>
        <Typography
          variant="body1"
          paragraph
        >
          <a
            href="https://www.scoir.com/colleges/pricing"
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn More
          </a>
        </Typography>
      </Box>
      <Box
        display="flex"
        justifyContent="center"
        p={2}
      >
        <img
          height={200}
          alt=""
          src={outreachEmptyState}
        />
      </Box>
    </Container>
  )
}

export default MarketingEmptyState
